// Third party libraries
import * as $ from 'jquery';
import DatePicker from 'vue2-datepicker';
import { vuelidateUtil } from '@/utils/vuelidate-util.js';
import { format } from 'date-fns';

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { userMixins } from '@/app/mixins/modules/user-mixins.js';
import { dateMixins } from '@/app/mixins/utils/date-mixins.js';

// Services
import treatmentService from '@/app/services/main/treatment/treatment-service.js';

// Constants
import { STATUS_CODES } from '@/app/constants/status-constants';

export default {
    name: 'ModifyTreatmentModal',
    components: {
        DatePicker
    },
    mixins: [ 
        toastMessageMixins, 
        userMixins, 
        dateMixins 
    ],
    data() {
        return {
            treatmentDate: '',
            isApplyAPILoading: false
        }
    },
    props: {
        modalContent: {
            type: Object,
            default: null
        }
    },
    watch: {
        'modalContent': {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    let originalSchedule = new Date(newVal.originalApplicationSchedule);
                    let date = originalSchedule < new Date() ? originalSchedule : new Date();
                    this.treatmentDate = format(date, 'dd-MMM-yyyy');
                }
            },
            deep: true
        }
    },
    computed: {
        validationRules() {
            let fields = {
                treatmentDate: {}
            };

            fields = vuelidateUtil.setRequiredValidation(fields, 'treatmentDate');
            fields = vuelidateUtil.setIsFutureDate(fields, 'treatmentDate');
            return fields;
        }
    },
    beforeDestroy() {
        this.closeModal();
    },
    methods: {
        show() {
            $('#treatmentModal').modal('show');
        },
        closeModal() {
            $('#treatmentModal').modal('hide');
        },
        applyTreatment() {
            if (this.$v.$invalid) {
                return;
            }

            let body = {
                dateApplied: this.dateToISO(this.treatmentDate)
            };

            this.isApplyAPILoading = true;

            // Call the API for the request
            treatmentService.putTreatment(this.modalContent.id, body)
                .then(res => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        let nextDate = format(new Date(res.data.nextTreatmentScheduleDate), 'dd-MMM-yyyy') ;
                        this.$emit('applyTreatment', nextDate);
                        this.closeModal();
                    } else {
						const { ERROR_APPLY_TREATMENT } = this.toastMessages.treatment(this.modalContent.product.name);
						this.showAPIErrorToast(ERROR_APPLY_TREATMENT, res);
                    }

                    this.isApplyAPILoading = false;
                })
                .catch(() => {
                    this.showGenericErrorToast();
                    this.isApplyAPILoading = false;
                })
        },
    },
    validations() {
        return this.validationRules;
    }
}